export default "__VITE_ASSET__q7HyttzH__"